import { axios, HOST, config } from "./settiing";

export default {
  getCustomerList(registerType, params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(
      `${HOST}/resource/web/customer/${registerType}?${query}`,
      config
    );
  },
  getCustomer(customerId) {
    return axios.get(`${HOST}/resource/customer/${customerId}`, config);
  },
  addCustomer(data) {
    return axios.post(`${HOST}/resource/customer`, data, config);
  },
  updateCustomer(data) {
    return axios.put(`${HOST}/resource/customer`, data, config);
  },
  deleteCustomer(customerId) {
    return axios.delete(`${HOST}/resource/customer/${customerId}`, config);
  },
  deleteCustomers(customers) {
    return axios.post(
      `${HOST}/resource/customer/bulk/remove`,
      customers,
      config
    );
  },
  getCustomerListByDate(start, end) {
    return axios.get(`${HOST}/resource/customer/date/${start}/${end}`, config);
  },
  customerMobileDulpCheck(data) {
    return axios.get(
      `${HOST}/resource/customer/check/byMobileNo/${data}`,
      config
    );
  },
  getMoffCustomerList(joinerId) {
    return axios.get(`${HOST}/resource/customer/moff/${joinerId}`, config);
  },

  getCustomerByCustomerInfo(info) {
    return axios.get(`${HOST}/resource/customer/search/${info}`, config);
  },

  customerBulkRegist(data) {
    return axios.post(`${HOST}/resource/customer/bulk`, data, config);
  },
  updateCustomerExpectedDate(data) {
    return axios.put(
      `${HOST}/resource/customer/expectedDeliveryDate`,
      data,
      config
    );
  },
  // CustomerState
  getCustomerStateList(data) {
    return axios.get(`${HOST}/resource/customerState/${data}`, config);
  },

  getCustomerInfoByNameOrLastNumber(name, lastNumber) {
    return axios.get(`${HOST}/resource/customer/search/nameOrNumber/`, {
      ...config,
      params: { name: name, lastNumber: lastNumber },
    });
  },

  getCustomerInfoExcel(filename) {
    return axios.get(`${HOST}/resource/customer/download/${filename}`, {
      ...config,
      withCredentials: true,
      responseType: "blob",
    });
  },
};
